export default "/assets/images/widgets-background-dark.6976cc84b2b18ee8.jpg";